import { Box, Chip, Paper, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useFoerderProgramm } from 'src/context/FoerderProgrammContext';
import { addIndexToPath, T } from 'src/utils/helper';

// import schemas
import FoerderRichtlinieSchema from 'src/lib/paths/foerderrichtlinie_DETAILS_SEITE_Paths.json';
let FR_P = FoerderRichtlinieSchema.attributes;

const ProgrammKeywordsSection: FC<{}> = () => {
	const { foerderRichtlinieDetails } = useFoerderProgramm();

	return (
		<Paper sx={{ p: '2rem' }}>
			<Typography>Keywords</Typography>
			<Box sx={{ mt: '1rem' }}>
				<Grid2 container spacing={1}>
					{get(foerderRichtlinieDetails, FR_P.Keywords_Keywords.path, []).map((_ele: any, i: number) => {
						return (
							<Grid2 key={i} xs='auto'>
								<Chip
									label={T(
										get(
											foerderRichtlinieDetails,
											addIndexToPath(FR_P.Keywords_Keywords.schema.attributes.Allgemein_Bezeichnung.path, i, FR_P.Keywords_Keywords.path),
											''
										)
									)}
									color='secondary'
								/>
							</Grid2>
						);
					})}
				</Grid2>
			</Box>
		</Paper>
	);
};

export default ProgrammKeywordsSection;
